import { Turnstile } from "@marsidev/react-turnstile";
import { TURNSTILE_SITE_KEY } from "~/lib/constants";

/**
 * Cloudflare Turnstile spam check, web only. Bumping `resetKey` remounts the
 * widget, which is how a form asks for a fresh token after each attempt
 * (a token can only be used once).
 */
export function TurnstileField({
  onToken,
  resetKey = 0,
}: {
  onToken: (token: string | null) => void;
  resetKey?: number;
}) {
  if (!TURNSTILE_SITE_KEY) return null;
  return (
    <Turnstile
      key={resetKey}
      siteKey={TURNSTILE_SITE_KEY}
      onSuccess={onToken}
      onExpire={() => onToken(null)}
      onError={() => onToken(null)}
    />
  );
}
